import { dataLoader } from './dataLoader.js';
import { dataCache } from './dataCache.js';

const TEMPLATE_CONFIG_URL = '/config/templates.json';
const I18N_CONFIG_URL = '/config/i18n.json';

class ConfigStore {
  constructor() {
    this.templates = null;
    this.i18n = null;
  }

  async init() {
    if (this.templates && this.i18n) return;

    const cachedTemplates = dataCache.get('templates');
    const cachedI18n = dataCache.get('i18n');

    if (cachedTemplates && cachedI18n) {
      this.templates = cachedTemplates;
      this.i18n = cachedI18n;
    } else {
      const [templates, i18n] = await dataLoader.loadAll([
        TEMPLATE_CONFIG_URL,
        I18N_CONFIG_URL
      ]);
      this.templates = templates;
      this.i18n = i18n;
      dataCache.set('templates', templates);
      dataCache.set('i18n', i18n);
    }
  }

  getTemplates() {
    return this.templates;
  }

  getI18n() {
    return this.i18n;
  }

  findFengShuiConfig(subzoneName, planningAreaName) {
    const mappings = this.templates?.regionMappings || {};
    return mappings[subzoneName] || mappings[planningAreaName] || null;
  }
}

export const configStore = new ConfigStore();
